import React, { Component } from "react";
import axios, { CancelToken } from "axios";
import { I18n } from "react-redux-i18n";
import { momentModule } from "../utils/Utils";
import { connect } from "react-redux";
import { setAlert } from "../../actions/alertActions";

import ComponentSelector from "../utils/components/ComponentSelector";
import Insights from "./Insights";
import History from "./History";
import Reports from "./Reports";

import {
  manipulateInsights,
  manipulateFilteredInsights,
} from "./manipulateInsights";

import "../../styles/components/insights/Stats.scss";
const { moment } = momentModule;

class Stats extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;
    this.cancelDrivers = null;

    this.state = {
      from: moment().subtract(1, "month").startOf("day"),
      to: moment().endOf("day"),
      driversFilter: ["all", "me"],
      selectedDriver: "all",
      fetchedInsights: null,
      loading: true,

      myEvs: null,
      myChargers: null,
      myRating: 0,
      myGroups: null,
      myFleets: null,
      tabChanged: false,

      selectedEV: null,
      selectedCharger: null,
    };

    this.handleOnDateChange = this.handleOnDateChange.bind(this);
    this.manipulateInsights = this.manipulateInsights.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    /* this.fetchInsights();
    this.fetchDrivers(); */
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting!");
    if (this.cancelDrivers) this.cancelDrivers("Component is unmounting!");
  }

  fetchDrivers() {
    if (this.cancelDrivers) this.cancelDrivers("New request made!");

    axios
      .get("/api/private/drivers", {
        cancelToken: new CancelToken((c) => (this.cancelDrivers = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          const me = {
            _id: this.props.accountData.id,
            name:
              this.props.accountData.name +
              I18n.t("backOffice_insights_myAccountName"),
            driverId: this.props.accountData.id,
            mobile: this.props.accountData.phone,
            internationalPrefix: this.props.accountData.internationalPrefix,
          };

          this.safeSetState({
            selectedDriver: "all",
            driversFilter: ["all"]
              .concat(
                res.data.poolOfDrivers.filter(
                  (user) =>
                    user.hasOwnProperty("driverId") && user.driverId !== ""
                )
              )
              .concat([me]),
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  /*
    Fetches the Insights from Back-End
  */
  fetchInsights() {
    if (this.cancel) this.cancel("New request made!");

    this.safeSetState(
      {
        loading: true,
      },
      () =>
        axios
          .get("/api/private/insights/backOffice", {
            cancelToken: new CancelToken((c) => (this.cancel = c)),
            params: {
              startDate: new Date(this.state.from),
              endDate: new Date(this.state.to),
            },
          })
          .then((res) => {
            if (res.status === 200) {
              /*               res.data.insights.forEach(insight => {
                if(insight.charger.network === "MobiE"){
                  console.log("FOUND: ", insight)
                }
              }); */

              this.manipulateInsights(res.data, this.props.accountData.id, () =>
                this.safeSetState({
                  loading: false,
                })
              );
            }
          })
          .catch((err) =>
            this.props.setAlert(I18n.t(err.response.data.message), "danger")
          )
    );
  }

  fetchMyGroups(callback) {
    axios
      .get("/api/private/groupCSUsers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
        params: {
          startDate: new Date(this.state.from),
          endDate: new Date(this.state.to),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState(
            {
              myGroups: res.data,
            },
            callback
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  /*
    Manipulates the data fetched from the new waypoint, this was necessary to pass data manipulation from back-end to front-end (performance boost).
  */
  manipulateInsights(insights, userId, callback) {
    this.safeSetState({ selectedDriver: "all" });

    let clientFleets = JSON.parse(JSON.stringify(insights.fleetsMyClients));

    clientFleets.forEach((fleet) => {
      fleet.myClient = true;
    });

    const myFleets = insights.myFleets.concat(clientFleets);

    //fetches fleets first, then fetches groups and only than manipulates data (Callbacks Made)
    this.safeSetState(
      {
        myFleets: myFleets,
      },
      this.fetchMyGroups(() => {
        const manipulatedInsights = {
          data: manipulateInsights(
            insights.insights,
            insights.myChargers,
            insights.myEvs,
            insights.evsIOwn,
            userId,
            String(userId) === String(this.props.accountData.id) ? true : false,
            this.state.myGroups,
            this.state.myFleets,
            insights.myInfrastructure
          ),
        };

        /*
        Insights are stored in state.fetchedInsights to be re-utilized in manipulateFilteredInsights() in order to minimize bak-end requests
        */
        this.safeSetState(
          (prevState) => ({
            fetchedInsights: insights,
            myEvs: manipulatedInsights.data.myEvs,
            myInfrastructures: insights.myInfrastructure.map(
              (infrastructure) => {
                if (Array.isArray(infrastructure.listChargers)) {
                  const listChargers = [];
                  infrastructure.listChargers.forEach((charger) => {
                    const chargerObj = insights.myChargers.find(
                      (c) => c._id === charger.chargerId
                    );
                    if (chargerObj) listChargers.push(chargerObj);
                  });
                  return {
                    ...infrastructure,
                    listChargers,
                  };
                }
              }
            ),
            myChargers: manipulatedInsights.data.myChargers,
            myRating: manipulatedInsights.data.myRating,
            selectedEV: this.updateSelectedEV(prevState, manipulatedInsights),
            selectedCharger: this.updateSelectedCharger(
              prevState,
              manipulatedInsights
            ),
          }),
          callback
        );
      })
    );
  }

  /*
    Only used for filtered data (filter by driver). Last parameter is a boolean used to indicate if the user is fetching is own insights
  */
  manipulateFilteredInsights(insights, userId, callback) {
    let clientFleets = JSON.parse(JSON.stringify(insights.fleetsMyClients));

    clientFleets.forEach((fleet) => {
      fleet.myClient = true;
    });

    const myFleets = insights.myFleets.concat(clientFleets);

    //fetches fleets first, then fetches groups and only than manipulates data (Callbacks Made)
    this.safeSetState(
      {
        myFleets: myFleets,
      },
      this.fetchMyGroups(() => {
        const manipulatedInsights = {
          data: manipulateFilteredInsights(
            insights.insights,
            insights.myChargers,
            insights.myEvs,
            insights.evsIOwn,
            userId,
            String(userId) === String(this.props.accountData.id) ? true : false,
            this.state.myGroups,
            this.state.myFleets
          ),
        };

        this.safeSetState(
          (prevState) => ({
            myEvs: manipulatedInsights.data.myEvs,
            myInfrastructures: insights.myInfrastructure,
            myChargers: manipulatedInsights.data.myChargers,
            myRating: manipulatedInsights.data.myRating,
            selectedEV: this.updateSelectedEV(prevState, manipulatedInsights),
            selectedCharger: this.updateSelectedCharger(
              prevState,
              manipulatedInsights
            ),
            myFleets: insights.myFleets,
          }),
          callback
        );
      })
    );
  }

  handleOnDateChange(e, date, callback) {
    this.safeSetState(
      {
        [date]: this.checkNewDates(e, date),
        driversFilter: ["all", "me"],
        selectedDriver: "all",
        fetchedInsights: null,
        loading: true,

        myEvs: null,
        myChargers: null,
        myRating: 0,

        selectedEV: null,
        selectedCharger: null,
      },
      () => {
        this.fetchDrivers();
        this.fetchInsights();
        callback();
      }
    );
  }

  checkNewDates(e, date) {
    if (date === "from") {
      return new Date(moment(e.target.value).startOf("day"));
    } else {
      return new Date(moment(e.target.value).endOf("day"));
    }
  }

  updateSelectedEV(prevState, res) {
    if (res.data.myEvs && res.data.myEvs.evs)
      if (res.data.myEvs.evs.length > 0)
        if (prevState.selectedEV !== null) {
          const index = res.data.myEvs.evs.findIndex(
            (i) => i._id === prevState.selectedEV._id
          );
          if (index !== -1) return res.data.myEvs.evs[index];
          else return res.data.myEvs.evs[0];
        } else return res.data.myEvs.evs[0];
      else return null;
    else return null;
  }

  updateSelectedCharger(prevState, res) {
    if (res.data.myChargers && res.data.myChargers.chargers)
      if (res.data.myChargers.chargers.length > 0)
        if (prevState.selectedCharger !== null) {
          const index = res.data.myChargers.chargers.findIndex(
            (i) => i._id === prevState.selectedCharger._id
          );
          if (index !== -1) return res.data.myChargers.chargers[index];
          else return res.data.myChargers.chargers[0];
        } else return res.data.myChargers.chargers[0];
      else return null;
    else return null;
  }

  // Resets the state and fetches all when user switches from page to page.
  updateInsights() {
    this.safeSetState(
      {
        loading: false,
      },
      () => {
        this.fetchInsights();
        this.fetchDrivers();
      }
    );
  }

  changeTab() {
    this.safeSetState({
      tabChanged: !this.state.tabChanged,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="stats" className="evio-container sidebar-fix main-component">
        <ComponentSelector
          changeTab={() => this.changeTab()}
          tabs={[
            {
              title: "label_insights",
              component: (
                <Insights
                  //States
                  from={this.state.from}
                  to={this.state.to}
                  myEvs={this.state.myEvs}
                  myChargers={this.state.myChargers}
                  myRating={this.state.myRating}
                  fetchedInsights={this.state.fetchedInsights}
                  selectedEV={this.state.selectedEV}
                  selectedCharger={this.state.selectedCharger}
                  driversFilter={this.state.driversFilter}
                  selectedDriver={this.state.selectedDriver}
                  loading={this.state.loading}
                  //Functions
                  fetchInsights={() => this.fetchInsights}
                  fetchDrivers={() => this.fetchDrivers}
                  handleOnDateChange={this.handleOnDateChange}
                  manipulateInsights={this.manipulateInsights}
                  manipulateFilteredInsights={(a, b) =>
                    this.manipulateFilteredInsights(a, b)
                  }
                  updateInsights={this.updateInsights.bind(this)}
                  tabChanged={this.state.tabChanged}
                />
              ),
            },
            {
              title: "label_history",
              component: (
                <History
                  from={this.state.from}
                  to={this.state.to}
                  myEvs={!this.state.loading ? this.state.myEvs.evs : null}
                  myInfrastructures={
                    !this.state.loading ? this.state.myInfrastructures : null
                  }
                  myChargers={
                    !this.state.loading ? this.state.myChargers.chargers : null
                  }
                  myGroups={!this.state.loading ? this.state.myGroups : null}
                  myFleets={!this.state.loading ? this.state.myFleets : null}
                  handleOnDateChange={(a, b) => this.handleOnDateChange(a, b)}
                  loading={this.state.loading}
                  tabChanged={this.state.tabChanged}
                  allEvs={
                    this.state.fetchedInsights &&
                    this.state.fetchedInsights.myEvs.concat(
                      this.state.fetchedInsights.listEVsMyClients
                    )
                  }
                />
              ),
            },
            {
              title: "label_reports",
              component: (
                <Reports
                  myFleets={this.state.myFleets}
                  myGroups={this.state.myGroups}
                />
              ),
            },
          ]}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(Stats);
